export default "__VITE_ASSET__DUb_e7Pp__"